import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Public "Our partners" strip. Merges two sources:
 *  1. `/api/public/partners` — legacy `partners` collection
 *  2. `/api/public/modules/footer-partners` — admin-managed module items
 *     (each item's data.link_url + data.logo_url drive the link and image)
 * Both are rendered in the same row so editors can mix and match.
 */
export default function FooterPartners() {
  const { t } = useTranslation();
  const [partners, setPartners] = useState([]);
  const [modulePartners, setModulePartners] = useState([]);
  useEffect(() => {
    fetch(`${API}/public/partners`).then(r => r.json()).then(d => setPartners(d.partners || [])).catch(() => {});
    fetch(`${API}/public/modules/footer-partners`).then(r => r.ok ? r.json() : null).then(d => {
      setModulePartners(d?.items || []);
    }).catch(() => {});
  }, []);

  const total = partners.length + modulePartners.length;
  if (total === 0) return null;

  return (
    <div className="bg-slate-900 border-b border-slate-800" data-testid="footer-partners">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h3 className="text-xs font-bold uppercase tracking-widest text-gray-400 text-center mb-5">{t('partners.title')}</h3>
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8">
          {partners.map(p => {
            const style = {};
            if (p.max_height) style.maxHeight = `${p.max_height}px`;
            if (p.max_width) style.maxWidth = `${p.max_width}px`;
            const cls = (p.max_height || p.max_width)
              ? 'object-contain w-auto'
              : 'h-10 sm:h-12 object-contain';
            return (
              <a key={p.id} href={p.website_url || '#'} target="_blank" rel="noopener noreferrer" title={p.name}
                className="opacity-60 hover:opacity-100 grayscale hover:grayscale-0 transition-all"
                data-testid={`partner-${p.id}`}>
                <img src={p.logo_url} alt={p.name} className={cls} style={style} />
              </a>
            );
          })}
          {modulePartners.map(p => (
            <a key={`m-${p.id}`} href={p.data?.link_url || '#'} target="_blank" rel="noopener noreferrer" title={p.title}
              className="opacity-60 hover:opacity-100 grayscale hover:grayscale-0 transition-all"
              data-testid={`partner-module-${p.id}`}>
              {p.data?.logo_url ? (
                <img src={p.data.logo_url} alt={p.title} className="h-10 sm:h-12 object-contain" />
              ) : (
                <span className="text-xs text-gray-300 font-semibold px-3 py-2 border border-gray-700 rounded">
                  {p.title}
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
